import { gql } from "@apollo/client";

export const DELETE_CONEXION = gql`
    mutation RemoveConexion (
        $idConexion: Int!
    ){
        removeConexion (
            idConexion: $idConexion
        )
    }
`;